import(/* webpackMode: "eager" */ "/Users/connorspackman/Developer/Cylerian/website/components/CTA/CTA.scss");
;
import(/* webpackMode: "eager" */ "/Users/connorspackman/Developer/Cylerian/website/components/Modules/Modules.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/connorspackman/Developer/Cylerian/website/components/PlatformHero/PlatformHero.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/connorspackman/Developer/Cylerian/website/components/StorylaneHero/StorylaneHero.js");
;
import(/* webpackMode: "eager" */ "/Users/connorspackman/Developer/Cylerian/website/node_modules/next/dist/client/link.js");
